import { Route } from '@angular/router';
import { PermissionFeature } from '@price-management-console/permissions';
import { Home } from '../app/home/home';
import { CommonErrorComponent } from './core/common-error/common-error.component';
import { authGuard } from './core/guards/auth.guard';
import { hasAnyPermissionGuard } from './core/guards/has-any-permission.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { AuthenticatedLayout } from './core/shell/authenticated-layout/authenticated-layout/authenticated-layout';
import { AuthenticatedStandaloneLayout } from './core/shell/authenticated-standalone-layout/authenticated-standalone-layout';
import { PublicLayout } from './core/shell/public-layout/public-layout/public-layout';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AuthenticatedLayout,
    canActivate: [authGuard, hasAnyPermissionGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        component: Home,
      },
      {
        path: 'routing-protocol',
        canActivate: [permissionGuard],
        data: {
          feature: PermissionFeature.RoutingProtocol,
        },
        loadChildren: () =>
          import('@price-management-console/routing-protocol').then(
            (m) => m.routingProtocolRoutes
          ),
      },
      {
        path: 'rate-management',
        canActivate: [permissionGuard],
        data: {
          feature: PermissionFeature.RateManagement,
        },
        loadChildren: () =>
          import('@price-management-console/rate-management').then(
            (m) => m.rateManagementRoutes
          ),
      },
    ],
  },
  {
    path: 'rate-management',
    component: AuthenticatedStandaloneLayout,
    canActivate: [authGuard],
    // canActivateChild: [permissionGuard],
    data: {
      feature: PermissionFeature.RateManagement,
    },
    children: [
      {
        path: 'commodity-list',
        loadComponent: () =>
          import('@price-management-console/rate-management').then(
            (module) => module.CommodityListComponent
          ),
      },
      {
        path: 'manage-qualifiers',
        loadChildren: () =>
          import('@price-management-console/rate-management').then(
            (module) => module.manageQualifiersRoutes
          ),
      },
    ],
  },
  {
    path: '',
    component: PublicLayout,
    children: [
      {
        path: 'error/:code',
        component: CommonErrorComponent,
      },
    ],
  },
];
